




















































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { User } from '@/models/user';
import LanguageChooser from '@/components/utils/LanguageChooser.vue';
import type { CompanySetting } from '@/models/companySetting';
import { hasAnyPermission, hasPermission, isSuperAdmin } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';
import { goToMainLink } from '@/helpers/routing/links';
import { combinedKnowledgePermissions } from '@/helpers/auth/commonPermissions';

@Component({
    name: 'SideBar',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { goToMainLink, isSuperAdmin, hasPermission },
    components: {
        LanguageChooser,
    },
})
export default class SideBar extends Vue {
    @Getter('account/userInfo') private userInfo: User;
    @Getter('account/loggedIn') private loggedIn: boolean;
    @Getter('approval/countAllOpenLessons') private countAllOpenLessons: number;
    @Getter('worksheet/countAllToDos') private countAllToDos: number;
    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('notifications/count') private notificationCount: number;
    @Getter('utils/currentLocale') private currentLocale: string;

    private activeQuickView: string = '';

    get currentRoutePath() {
        return this.$store.getters['utils/currentRoutePath'];
    }
    set currentRoutePath(route: string) {
        this.$store.commit('utils/setCurrentRoutePath', route);
    }

    get tabPMTitle() {
        return this.currentLocale === 'en' ? this.companySetting.pm_en_tab_title : this.companySetting.pm_de_tab_title;
    }

    get tabXTitle() {
        return this.currentLocale === 'en' ? this.companySetting.x_en_tab_title : this.companySetting.x_de_tab_title;
    }

    private mounted() {
        // Currently do nothing
    }

    get canSeeKnowledgeQuickView() {
        return hasAnyPermission([
            PERMISSIONS.APPEX_TOPIC,
            PERMISSIONS.APPEX_PHASE,
            PERMISSIONS.APPEX_TAG,
            PERMISSIONS.APPEX_KNOWLEDGE_SETTINGS,
        ]);
    }

    get canSeeKnowledge() {
        return this.canSeeKnowledgeQuickView || this.canSeeCombinedKnowledge;
    }

    get canSeeCombinedKnowledge() {
        return hasAnyPermission(combinedKnowledgePermissions);
    }

    get canSeeApproval() {
        return hasAnyPermission([
            PERMISSIONS.APPEX_LESSON_APPROVE,
            PERMISSIONS.APPEX_PM_LESSON_APPROVE,
            PERMISSIONS.APPEX_X_LESSON_APPROVE,
        ]);
    }

    get canSeeAdmin() {
        return (
            hasAnyPermission([
                PERMISSIONS.APPEX_ADMIN_USER,
                PERMISSIONS.APPEX_COMPANY_EDIT,
                PERMISSIONS.APPEX_PROJECT_ALL,
                PERMISSIONS.APPEX_INTEGRATIONS,
            ]) ||
            isSuperAdmin(this.userInfo) ||
            this.canSeeDynamicField
        );
    }

    get canSeeDynamicField() {
        return hasPermission(PERMISSIONS.APPEX_DYNAMIC_FIELD) && this.companySetting.feature_dynamic_worksheet_field;
    }

    private goToRoutePath(route: string) {
        if (route === '/knowledge/combined') {
            this.resetTabsIndexInKnowledge();
        }
        if (route && this.$route.path !== route) {
            this.currentRoutePath = route;
            this.activeQuickView = '';
            this.$router.push({ path: route });
        }
    }

    private resetTabsIndexInKnowledge() {
        this.$store.commit('knowledge/setActiveTab', 0);
        this.$store.commit('knowledge/setConceptsActivePhaseTabIndex', 0);
        this.$store.commit('knowledge/setTradesActivePhaseTabIndex', 0);
    }

    private checkRoutePath(route: string) {
        // console.log(this.currentRoutePath, route);
        if (this.currentRoutePath.includes(route)) {
            return 'is-active';
        }
    }

    private toggleQuickView(view: string) {
        if (this.activeQuickView === view) {
            this.activeQuickView = '';
        } else {
            this.activeQuickView = view;
        }
    }

    private checkActiveView(view: string) {
        if (this.activeQuickView === view) {
            return 'is-active';
        }
    }
}
